import { ReactNode } from "react";

type BasePageType = {
  children: ReactNode;
};

export default function BasePage(props: BasePageType) {
  return (
    <section
      id="_"
      className="text-[#f2e6da] w-full overflow-x-clip flex flex-col justify-center items-center grow"
    >
      {props.children}
    </section>
  );
}
